import React, { Fragment, useState, useEffect } from "react";
import { Redirect } from "react-router-dom";
import { logout } from "../actions/auth";
import { useSelector, useDispatch } from "react-redux";
import Button from "@mui/material/Button";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import { Link, Navigate, useNavigate } from "react-router-dom";
import {
  alertMessage,
  DOMAIN_URL,
  SIDEBAR,
  ONLYLOGO,
  GRADIENT,
  APPBAR,
} from "../actions/auth";
import CircularProgress from "@mui/material/CircularProgress";

import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import { themeStyle } from "../components/Components.js";

export default function Logout() {
  const dispatch = useDispatch();
  function createAlert(type, title, message) {
    dispatch(alertMessage(type, title, message));
  }
  const navigate = useNavigate();
  const params = new URLSearchParams(window.location.search);
  const state = useSelector((state) => state);
  const [isLoggingOut, setIsLoggingOut] = useState(false);

  function getout() {
    setIsLoggingOut(true);
    dispatch(logout());
    return null;
  }

  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    setLoaded(true);
  }, []);

  return (
    <Fragment>
      <div
        style={{
          height: "100vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          transition: "opacity 1s",
          opacity: loaded ? 1 : 0,
        }}
      >
        <div
          style={{
            width: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            backgroundImage: GRADIENT,
            height: "100%",
            paddingTop: "50px",
          }}
        >
          <AppBar
            position="fixed"
            style={{
              backgroundColor: "white",
            }}
          >
            <Toolbar
              style={{
                display: "flex",
                justifyContent: "space-between",
              }}
            >
              <a style={{ textDecoration: "none" }} href={DOMAIN_URL}>
                <img
                  style={{ maxHeight: "50px", margin: "10px" }}
                  src={require("../img/" + APPBAR)}
                />
              </a>
              <a style={{ textDecoration: "none" }} href={DOMAIN_URL}>
                <Button
                  style={{
                    backgroundColor: "white",
                    color: "black",
                    fontSize: "16px",
                    marginTop: "3px",
                  }}
                >
                  <ChevronLeftIcon style={{ fontSize: "35px" }} /> Back to Home
                </Button>
              </a>
            </Toolbar>
          </AppBar>
          <div
            style={{
              padding: "50px",
              backgroundColor: "white",
              textAlign: "center",
              borderRadius: "6px",
            }}
          >
            <div style={{ marginTop: "-30px" }}>
              <h2>Do you want to Log out?</h2>
              <br></br>
              <Button
                style={{
                  height: "40px",
                  backgroundColor: themeStyle.primaryColor,
                }}
                type="button"
                onClick={() => getout()}
                variant="contained"
              >
                <span
                  style={{
                    fontSize: "18px",
                    width: "150px",
                    height: "30px",
                  }}
                >
                  Logout
                </span>{" "}
              </Button>
              {isLoggingOut ? (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    marginTop: "20px",
                  }}
                >
                  <CircularProgress />{" "}
                </div>
              ) : (
                <span></span>
              )}
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
}
